import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PlanAJourneyLeftContainer from "./PlanAJourneyLeftContainer";
import PlanAJourneyRightContainer from "./PlanAJourneyRightContainer";
import { TicketValidityList } from "./TicketValidityList";
import dayjs from "dayjs";
import { fetchDestination } from "../../services/bookingServices";
import {
  fetchUserData,
  getEntitlementBalance,
  getUsersPassport,
} from "../../services/userServices";
import {
  getFormattedPax,
  getFormattedDestinationSelectfieldData,
  getSapError,
  getIsDisclaimer,
} from "../../helper";
import { useBookingContext } from "../../contexts/BookingContext";
import { useGuestContext } from "../../contexts/GuestContext";
import { usePaxContext } from "../../contexts/PassengerContext";
import { useSearchParams } from "react-router-dom";
import { useLoaderContext } from "../../contexts/loaderContext";
import { useDestinationContext } from "../../contexts/DestinationContext";
import { sapErrorValidation, validateRequest } from "./ValidateRequest";
import { isArray } from "underscore";
import { airports } from "../../config/airports";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";
import { toast } from "react-toastify";
import { ToastMessage } from "../../components/ToastMessage";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import { Colors } from "../../config";
import {
  EXCEPTIONAL_NATIONALITIES,
  EXCEPTIONAL_NATIONALITIES_PRICE,
  TRAVEL_CLASS,
} from "../../config/Constants";
import { useProfileContext } from "../../contexts/ProfileContext";

const Home = () => {
  const { booking: formData, setBooking } = useBookingContext();
  const { guests, setGuests } = useGuestContext();
  const { profile, setProfile } = useProfileContext();
  const { destinations, setDestinations } = useDestinationContext();
  const { passengers, setPax } = usePaxContext();
  // const [formData, setBooking] = useState();
  const { setLoader } = useLoaderContext();

  // const [destinations, setDestinations] = useState();

  const [travelClass, setTravelClass] = useState("");
  const [fellowPax, setFellowPax] = useState([]);
  const [profileData, setProfileData] = useState({});
  const navigate = useNavigate();
  const [destinationConfirmModal, setDestinationConfirmModal] = useState(false);
  const [exceptionCountryModal, setExceptionCountryModal] = useState(false);
  const [tempDestination, setTempDestination] = useState("");
  const [isReturnTypeChange, setReturnTypeChange] = useState(false);

  const [fieldError, setFieldError] = useState({
    to: "",
    departureTime: "",
    returnTime: "",
    perferAirline: "",
    passengers: "",
    guests: [],
  });

  const { extraFields, setExtraFields } = useExtraFieldsContext();
  const [fileNames, setFileNames] = useState(extraFields.passportFileNames);

  const [sapErrorList, setSapErrorList] = useState(extraFields.sapErrorList);
  const [isDisclaimer, setIsDisclaimer] = useState(extraFields.isDisclaimer);
  const [passportPdfs, setPassportPdfs] = useState();
  let passportInter = passportPdfs;

  useEffect(() => {
    // if(!profile.personId) return;
    fetchPassportPdfs();
    fetchEmployeeData();
    // fetchEntitlementBalance();
  }, []);

  

  const fetchEntitlementBalance = async () => {
    setLoader(true);
    try {
      let { data } = await getEntitlementBalance();
      console.log(data);
    } catch (error) {
      setLoader(false);
      // console.log("error", error);
    }
  };

  const fetchEmployeeData = async () => {
    setLoader(true);
    try {
      let { data } = await fetchUserData();
      // let data = { data: profile, code: 200 };
      setProfileData({ ...data?.data });
      setProfile({ ...data?.data });
      // setProfileData({ ...data?.data, territoryName: "Syrian Arab Republic" });
      setFellowPax([
        {
          firstName: data?.data?.firstName,
          lastName: data?.data?.lastName,
          relation: "Self",
          ticketEncash:
            data?.data?.ticketEncash > 0 ? data?.data?.ticketEncash : 0,
          entitlement: data?.data?.entitlement,
        },
        ...data?.data?.personRelationship,
      ]);

      if (passengers.length === 0) {
        let formattedPaxInter = getFormattedPax(data?.data, passportInter);
        setPax(formattedPaxInter);
        getSapErrorAndDisclaimer(formattedPaxInter);
        setLoader(false);
      }
      setExtraFields((prev) => ({
        ...prev,
        companyCode: data?.data.companyCode,
        lastWorkingDate: data?.data.lstWorkingDate,
        departmentCode: data?.data.departmentCode,
        categoryType: data?.data.categoryType,
        contactNum: data?.data.workPhoneNumber,
        photo: data?.data.photo,
        companyName: data?.data?.companyName,
        grade: data?.data?.grade,
      }));
      if (data.code === 200) {
        setLoader(false);
        if (destinations.length === 0) {
          // let res = await fetchDestination("DOH");
          setDestinations(
            getFormattedDestinationSelectfieldData(
              airports,
              "name",
              "iata_code"
            )
          );
        }
      }
    } catch (error) {
      setLoader(false);
      // console.log("error", error);
    }
  };

  const fetchPassportPdfs = async () => {
    try {
      let response = await getUsersPassport();
      if (response.status === 200) {
        passportInter = response.data.data;
        setPassportPdfs(response.data.data);
        // console.log(passportInter);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getSapErrorAndDisclaimer = (data) => {
    let sapErrorArr = getSapError(data);
    setSapErrorList(sapErrorArr);
    setExtraFields((prev) => ({
      ...prev,
      sapErrorList: sapErrorArr,
    }));

    // let disclaimerNeeded = getIsDisclaimer(sapErrorArr);
    let disclaimerNeeded = true;
    setIsDisclaimer(disclaimerNeeded);
    setExtraFields((prev) => ({
      ...prev,
      isDisclaimer: disclaimerNeeded,
    }));
  };

  const handleCheckAirlines = (val, label) => {
    const updatedAirlines = [...formData.perferAirline];
    const numSelected = updatedAirlines.filter(
      (airline) => airline.selected
    ).length; // check if the checkbox is being selected and the limit has been reached
    if (val && numSelected === 5) {
      // toast.error(
      //   <ToastMessage message={"Max 5 airlines selection allowed"} />
      // );
      return;
    }
    let index = updatedAirlines.findIndex((i) => i.label === label);
    updatedAirlines[index].selected = val;
    setBooking({ ...formData, perferAirline: updatedAirlines });
    setFieldError((prev) => ({ ...prev, perferAirline: "" }));
  };

  const handleAddGuests = (e) => {
    e.preventDefault();
    const newGuest = {
      empId: passengers[0].empId,
      firstName: "",
      lastName: "",
      dob: "",
      gender: "",
      passportNo: "",
      relationshipStatus: "Guest",
      travelType: "Economy",
      paymentType: "self paid",
      passportExpiry: "",
      privilegeClub: "",
      passportPdf: "",
    };
    const fileName = "";
    if (guests.length === 0) {
      setGuests([newGuest]);
      setFileNames([fileName]);
    } else {
      setGuests([...guests, newGuest]);
      setFileNames([...fileNames, fileName]);
    }
    if (!isArray(fieldError.passengers)) {
      setFieldError((prev) => ({ ...prev, passengers: "" }));
    }
  };

  const handleRemove = (index) => {
    const updatedGuests = [...guests];
    updatedGuests.splice(index, 1);
    setGuests(updatedGuests);

    const updatedGuestsError = [...fieldError.guests];
    updatedGuestsError.splice(index, 1);
    setFieldError((prev) => ({ ...prev, guests: updatedGuestsError }));
  };

  const handleShowFlights = () => {
    console.log(formData?.to);
    // console.log(passengers);
    // console.log(guests);
    // setBooking({ formData, passengers, guests });
    if (
      !validateRequest(
        formData,
        passengers,
        guests,
        setFieldError,
        sapErrorList
      )
    ) {
      if (sapErrorValidation(passengers, sapErrorList)) {
        // let selfErrorData = sapErrorList.filter(
        //   (item, i) => passengers[i].relationshipStatus === "Self"
        // );
        toast.error(
          <ToastMessage
            message={
              "Please Update your latest Passport in SAP, and try again later"
            }
          />
        );
        return;
      }
      setExtraFields((prev) => ({ ...prev, passportFileNames: fileNames }));
      navigate("/user/dashboard/confirmRequest");
    } else {
      if (sapErrorValidation(passengers, sapErrorList)) {
        toast.error(
          <ToastMessage
            message={
              "Please Update your latest Passport in SAP, and try again later"
            }
          />
        );
      }
      toast.error(
        <ToastMessage message={"Please check if all the fields are filled."} />
      );
    }
  };

  const handleDirectFlightToggle = (value) => {
    setBooking({ ...formData, directFlight: value });
  };

  const handleFormChange = async (e) => {
    setBooking({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDestinationSelect = (val) => {
    const updatedfellowPax = [...passengers];

    let filteredFellowPax = updatedfellowPax.filter((pax) => pax.selected);

    let hasCompanyPaid = filteredFellowPax.some(
      (pax) => pax.paymentType === "company paid"
    );
    let selectedAirportCountry = destinations.filter(
      (dest) => dest.value === val
    )[0]?.country;
    if (EXCEPTIONAL_NATIONALITIES.includes(profileData.territoryName)) {
      if (selectedAirportCountry !== profileData.territoryName) {
        if (hasCompanyPaid) {
          if (!extraFields.exceptionNationModalShown) {
            setExceptionCountryModal(true);
          }
        }
      }
      setBooking({ ...formData, to: val });
      setFieldError((prev) => ({ ...prev, to: "" }));
    } else {
      if (selectedAirportCountry !== profileData.territoryName) {
        if (passengers.some((x) => x.paymentType === "company paid")) {
          if (extraFields.selfPaidModalShown) {
            let passengerArray = [...passengers];
            setBooking({ ...formData, to: val });
            setFieldError((prev) => ({ ...prev, to: "" }));
            passengerArray.forEach((pax) => (pax.paymentType = "self paid"));
            setPax(passengerArray);
          } else {
            setDestinationConfirmModal(true);
            setTempDestination(val);
          }
        } else {
          setBooking({ ...formData, to: val });
          setFieldError((prev) => ({ ...prev, to: "" }));
        }
      } else {
        setBooking({ ...formData, to: val });
        setFieldError((prev) => ({ ...prev, to: "" }));
      }
    }
  };

  const handleFromSelect = (val) => {
    setBooking({ ...formData, from: val });
    setFieldError((prev) => ({ ...prev, from: "" }));
  };

  const handleRevertDestination = () => {
    if (isReturnTypeChange) {
      setBooking({ ...formData, returnJourney: true });
      setDestinationConfirmModal(false);
    } else {
      let oldSelection = formData.to ?? "";
      setBooking({ ...formData, to: oldSelection });
      setDestinationConfirmModal(false);
      setTempDestination("");
    }
  };

  const handleSelectDestination = () => {
    let passengerArray = [...passengers];
    if (isReturnTypeChange) {
      setBooking({
        ...formData,
        returnJourney: false,
      });
    } else {
      let selectedDestination = tempDestination;
      setTempDestination("");
      setBooking({ ...formData, to: selectedDestination });

      setFieldError((prev) => ({ ...prev, to: "" }));
    }
    setDestinationConfirmModal(false);
    setExtraFields((prev) => ({
      ...prev,
      selfPaidModalShown: true,
    }));
    passengerArray.forEach((pax) => (pax.paymentType = "self paid"));
    setPax(passengerArray);
  };

  const handleDateSelection = (start, end) => {
    let departureDate = start ? dayjs(start).format("YYYY/MM/DD") : "";
    let returnDate = start ? dayjs(end).format("YYYY/MM/DD") : "";
    setBooking({ ...formData, departureDate, returnDate });
    setFieldError((prev) => ({ ...prev, departureReturnDate: "" }));
  };

  const handleTimeChange = (time, journeyType) => {
    if (journeyType === "departure") {
      setBooking({ ...formData, departureTime: time });
      setFieldError((prev) => ({ ...prev, departureTime: "" }));
    }
    if (journeyType === "return") {
      setBooking({ ...formData, returnTime: time });
      setFieldError((prev) => ({ ...prev, returnTime: "" }));
    }
  };

  const handlePassengerCheckbox = (val, index) => {
    const updatedfellowPax = [...passengers];
    updatedfellowPax[index].selected = !updatedfellowPax[index].selected;
    if (
      updatedfellowPax[index].selected &&
      updatedfellowPax[index].paymentType === "company paid"
    ) {
      setBooking({ ...formData, returnJourney: true });
    }
    setPax(updatedfellowPax);

    let updatedPassengersError = fieldError.passengers;
    if (isArray(updatedPassengersError))
      updatedPassengersError[index] = {
        paymentType: "",
        travelType: "",
      };
    else updatedPassengersError = "";
    setFieldError((prev) => ({ ...prev, passengers: updatedPassengersError }));
  };

  const handlePaymentSelect = (e, index, type) => {
    e.preventDefault();
    try {
      if (type === "passengers") {
        const updatedfellowPax = [...passengers];
        updatedfellowPax[index]["paymentType"] = e.target.value;
        if (
          e.target.value === "company paid" &&
          updatedfellowPax[index]["travelType"] === "Business Class"
        ) {
          updatedfellowPax[index]["travelType"] = TRAVEL_CLASS[0].value;
        }
        setPax(updatedfellowPax);

        let filteredFellowPax = updatedfellowPax.filter((pax) => pax.selected);

        let hasCompanyPaid = filteredFellowPax.some(
          (pax) => pax.paymentType === "company paid"
        );

        if (hasCompanyPaid) {
          setBooking({ ...formData, returnJourney: true });
        }

        const updatedPassengersError = [...fieldError.passengers];
        updatedPassengersError[index]["paymentType"] = "";
        setFieldError((prev) => ({
          ...prev,
          passengers: updatedPassengersError,
        }));
      }
      if (type === "guests") {
        const updatedGuests = [...guests];
        updatedGuests[index]["paymentType"] = e.target.value;
        setGuests(updatedGuests);

        const updatedGuestsError = [...fieldError.guests];
        updatedGuestsError[index]["paymentType"] = "";
        setFieldError((prev) => ({
          ...prev,
          guests: updatedGuestsError,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleClassSelect = (e, index, type) => {
    e.preventDefault();
    try {
      if (type === "passengers") {
        const updatedfellowPax = [...passengers];
        updatedfellowPax[index]["travelType"] = e.target.value;
        setPax(updatedfellowPax);

        const updatedPassengersError = [...fieldError.passengers];
        updatedPassengersError[index]["travelType"] = "";
        setFieldError((prev) => ({
          ...prev,
          passengers: updatedPassengersError,
        }));
      }
      if (type === "guests") {
        const updatedGuests = [...guests];
        updatedGuests[index]["travelType"] = e.target.value;
        setGuests(updatedGuests);

        const updatedGuestsError = [...fieldError.guests];
        updatedGuestsError[index]["travelType"] = "";
        setFieldError((prev) => ({
          ...prev,
          guests: updatedGuestsError,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleGuestChange = (e, index) => {
    const updatedGuests = [...guests];
    console.log(updatedGuests[index]);
    updatedGuests[index][e.target.name] = e.target.value;
    setGuests(updatedGuests);

    const updatedGuestsError = [...fieldError.guests];
    updatedGuestsError[index][e.target.name] = "";
    setFieldError((prev) => ({ ...prev, guests: updatedGuestsError }));
  };

  const handlePassportExpirySelect = (e, index) => {
    const updatedGuests = [...guests];
    console.log(updatedGuests[index]);
    console.log(e);
    updatedGuests[index]["passportExpiry"] = e;
    setGuests(updatedGuests);

    const updatedGuestsError = [...fieldError.guests];
    updatedGuestsError[index]["passportExpiry"] = "";
    setFieldError((prev) => ({
      ...prev,
      guests: updatedGuestsError,
    }));
  };

  const handleDobSelect = (e, index) => {
    const updatedGuests = [...guests];
    updatedGuests[index]["dob"] = e;
    setGuests(updatedGuests);

    const updatedGuestsError = [...fieldError.guests];
    updatedGuestsError[index]["dob"] = "";
    setFieldError((prev) => ({
      ...prev,
      guests: updatedGuestsError,
    }));
  };

  const handleCommentChange = (e) => {
    setBooking({ ...formData, bookingComments: e.target.value });
  };

  const handleUploadPassport = (obj, index) => {
    const updatedGuests = [...guests];
    updatedGuests[index]["passportPdf"] = obj.viewUrl ? obj.viewUrl : "";
    setGuests(updatedGuests);

    const updatedFileName = [...fileNames];
    updatedFileName[index] = obj.originalname ? obj.originalname : "";
    setFileNames(updatedFileName);

    const updatedGuestsError = [...fieldError.guests];
    updatedGuestsError[index]["passportPdf"] = "";
    setFieldError((prev) => ({
      ...prev,
      guests: updatedGuestsError,
    }));
  };

  const handleTypeSelect = (val) => {
    setReturnTypeChange(true);

    if (val) {
      setBooking({ ...formData, returnJourney: val, from: "" });
    } else {
      if (extraFields.selfPaidModalShown) {
        let passengerArray = [...passengers];
        passengerArray.forEach((pax) => (pax.paymentType = "self paid"));
        setPax(passengerArray);
        setBooking({
          ...formData,
          returnJourney: val,
        });
      } else {
        setDestinationConfirmModal(true);
      }
    }
  };

  const getAmount = (travelClass) => {
    console.log(profileData?.territoryName, travelClass);

    return (
      EXCEPTIONAL_NATIONALITIES_PRICE[profileData?.territoryName][
        travelClass
      ] || 0
    );
  };

  const onPassportNoAndExpiryChange = (val, name, index) => {
    const updatedfellowPax = [...passengers];
    updatedfellowPax[index][name] = val;
    setPax(updatedfellowPax);

    const updatedPassengersError = [...fieldError.passengers];
    updatedPassengersError[index][name] = "";
    setFieldError((prev) => ({
      ...prev,
      passengers: updatedPassengersError,
    }));
  };

  const onDependentsPassportUpload = (obj, index) => {
    const updatedPax = [...passengers];
    updatedPax[index]["passportPdf"] = obj.viewUrl ? obj.viewUrl : "";
    setPax(updatedPax);

    const updatedPassengersError = [...fieldError.passengers];
    updatedPassengersError[index]["passportPdf"] = "";
    setFieldError((prev) => ({
      ...prev,
      passengers: updatedPassengersError,
    }));
  };

  const handleContinueExceptionModal = () => {
    setExceptionCountryModal(false);
    setExtraFields((prev) => ({
      ...prev,
      exceptionNationModalShown: true,
    }));
  };

  return (
    <PageContainer>
      <PlanAJourneyLeftContainer
        ticketValidityList={fellowPax}
        isDisclaimer={isDisclaimer}
      />
      <PlanAJourneyRightContainer
        guests={guests}
        onRemove={handleRemove}
        onAddGuests={handleAddGuests}
        onSubmitRequest={handleShowFlights}
        passengers={passengers}
        // setDate={setDate}
        // timeSelect={timeSelect}
        // handleTimeChange={handleTimeChange}
        destinations={destinations}
        formData={formData}
        setFellowPax={setFellowPax}
        airlines={formData.perferAirline}
        setTravelClass={setTravelClass}
        handleCheckAirlines={handleCheckAirlines}
        fellowPax={fellowPax}
        onFormChange={handleFormChange}
        onDateSelection={handleDateSelection}
        onTimeRangeSelect={handleTimeChange}
        onDirectFlightToggle={handleDirectFlightToggle}
        onCheckboxChange={handlePassengerCheckbox}
        onPaymentSelect={handlePaymentSelect}
        onTravelClassSelect={handleClassSelect}
        onGuestChange={handleGuestChange}
        onPassportExpirySelect={handlePassportExpirySelect}
        onDestinationSelect={handleDestinationSelect}
        onFromSelect={handleFromSelect}
        fieldError={fieldError}
        handleCommentChange={handleCommentChange}
        handleDobSelect={handleDobSelect}
        handleUploadPassport={handleUploadPassport}
        fileNames={fileNames}
        setFileNames={setFileNames}
        sapErrorList={sapErrorList}
        profileData={profileData}
        onTypeSelect={handleTypeSelect}
        onPassportNoAndExpiryChange={onPassportNoAndExpiryChange}
        onDependentsPassportUpload={onDependentsPassportUpload}
      />
      {destinationConfirmModal && (
        <Modal setClose={() => setDestinationConfirmModal(false)}>
          <DestinationModalConfirm>
            Company provided tickets are to home country by Nationality. Please
            be aware that the payment type will be <strong>Self-Paid</strong> if
            you select a different destination or schedule a one-way trip.
            <div>
              <Button
                label="Cancel"
                leftRightPadding="0.5rem"
                topBottomPadding="0.5rem"
                outlineColor={Colors.brandTwo}
                fontColor={Colors.brandTwo}
                bgColor={Colors.white}
                onClick={handleRevertDestination}
              />
              <Button
                leftRightPadding="0.5rem"
                topBottomPadding="0.5rem"
                outlineColor={Colors.brandFive}
                fontColor={Colors.white}
                bgColor={Colors.brandTwo}
                label={"Continue"}
                onClick={handleSelectDestination}
              />
            </div>
          </DestinationModalConfirm>
        </Modal>
      )}

      {exceptionCountryModal && (
        <Modal setClose={() => setExceptionCountryModal(false)}>
          <DestinationModalConfirm>
            {`If you are unable to travel to your home country, you have the
            alternative option to book a ticket to a different destination.
            Any excess amount can be
            covered through self-pay option.`}
            <div>
              <Button
                leftRightPadding="0.5rem"
                topBottomPadding="0.5rem"
                outlineColor={Colors.brandFive}
                fontColor={Colors.white}
                bgColor={Colors.brandTwo}
                label={"Continue"}
                onClick={handleContinueExceptionModal}
              />
            </div>
          </DestinationModalConfirm>
        </Modal>
      )}
    </PageContainer>
  );
};

const DestinationModalConfirm = styled.div`
  width: 20rem;
  padding: 2rem;
  padding-bottom: 1rem;
  text-align: center;
  > div {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }
`;
const PageContainer = styled.div`
  padding: 0rem 2rem;
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0;
    box-sizing: border-box;
  }
`;

export default Home;
